const ASSET_CODE_TO_KEY = {
    J: 'jersey',
    P: 'pants',
    C: 'cap'
};
class UniformStatsModel {
    constructor (data) {
        const teams = data?.uniforms?.[0];

        // if both are missing, revert to fallback. But proceed even if only one.
        if (!teams?.home && !teams?.away) {
            return {
                home: { fullSet: 'fallback' },
                away: { fullSet: 'fallback' }
            };
        }

        const homeAssets = this.home = this[teams?.home?.id] = {};
        const awayAssets = this.away = this[teams?.away?.id] = {};

        teams?.home?.uniformAssets?.reduce(this.assetReducer, homeAssets);
        teams?.away?.uniformAssets?.reduce(this.assetReducer, awayAssets);

        if (teams?.home?.id) {
            homeAssets.fullSet = [homeAssets?.cap, homeAssets?.jersey, homeAssets?.pants].join(':');
        } else {
            homeAssets.fullSet = 'fallback';
        }

        if (teams?.away?.id) {
            awayAssets.fullSet = [awayAssets?.cap, awayAssets?.jersey, awayAssets?.pants].join(':');
        } else {
            awayAssets.fullSet = 'fallback';
        }
    }

    assetReducer (acc, asset) {
        const assetCode = asset.uniformAssetType?.uniformAssetTypeCode;
        const assetKey = ASSET_CODE_TO_KEY[assetCode];
        if (assetKey && asset.uniformAssetCode) {
            acc[assetKey] = asset.uniformAssetCode;
        }
        return acc;
    }
}

export default UniformStatsModel;
